import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import CardsWithMediaPlayer from '../CardsWithMediaPlayer/CardsWithMediaPlayer'
import Headline from '../Headline/Headline'
import UPIInteroperabilty from './UPIInteroperabilty'
import UPIInfrastructure from './UPIInfrastructure'

import styles from './UpiLayout.module.scss'
import { scrollElemToTop } from '../../utils'
import { INFRASTRUCTURE, INTEROPERABILITY } from '../../Contansts'

function UpiLayout({ cards, page = '', buttonText, hideVideo }) {
  let navigate = useNavigate()

  const infoRef = useRef(null)
  const [selectedCard, setSelectedCard] = useState(cards[0] || [])
  function cardClickHandler(card) {
    setSelectedCard(card)
  }

  const handleReadMoreClick = () => {
    if (infoRef.current) {
      scrollElemToTop(infoRef.current.offsetTop)
    }
  }

  const handleListOfCountryNavigation = (buttonDetails) => {
    navigate(buttonDetails.path || '')
  }

  return (
    <div className={styles.container}>
      <CardsWithMediaPlayer
        selectedCard={selectedCard}
        cards={cards}
        cardClickHandler={cardClickHandler}
        handleReadMoreClick={handleReadMoreClick}
        className={page === INFRASTRUCTURE && 'page-container'}
        buttonText={buttonText}
        hideVideo={hideVideo}
      />
      <div ref={infoRef} className={classNames(styles.infoContainer)}>
        {selectedCard?.headlinetitle && (
          <Headline
            title={selectedCard?.headlinetitle}
            paragraphs={selectedCard?.headlinedecription}
            className={page === INFRASTRUCTURE && 'page-container'}
          />
        )}
        {page === INTEROPERABILITY && (
          <UPIInteroperabilty
            selectedCard={selectedCard}
            handleNavigation={handleListOfCountryNavigation}
          />
        )}
        {page === INFRASTRUCTURE && (
          <UPIInfrastructure selectedCard={selectedCard} />
        )}
      </div>
    </div>
  )
}

export default UpiLayout
